export default "__VITE_PUBLIC_ASSET__3025f873__"